const CheckboxField = ({
    id,
    label,
    checked,
    disabled = false,
    onChange,
    className = "",
}) => {
    return (
        <label
            htmlFor={id}
            className={`flex items-center space-x-2 select-none my-4 ${className}`}
        >
            <input
                type="checkbox"
                id={id}
                disabled={disabled}
                checked={checked || false}
                onChange={onChange}
                className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />

            <span className="text-base font-medium text-black">
                {label}
            </span>
        </label>
    );
};

export default CheckboxField;